import React, { useState } from "react";
import { Box, CheckBox, Text } from "grommet";
import PrimaryButton from "../elements/primary_button";
import StandardText from "../elements/standar_text";

const DataPersonnel = ({onClose}) => {
    const [checked, setChecked] = useState(false);
    const [error, setError] = useState(false);

    return (
        <Box width={'large'} pad="medium" gap="medium">
            <Box direction="row" pad={"medium"} gap="medium" justify="start">
                <CheckBox value={checked} onChange={event => setChecked(event.target.checked)}></CheckBox>
                <StandardText
                    label={"En cochant cette case votre client accepte le collecte de ces informations personnelles afin de proposer à l’utilisateur une expérience optimale."}
                />
            </Box>
            <Box style={{ width: '100%' }} justify="center" align="center">
                <Box width={"medium"}>
                    <PrimaryButton
                        onClick={() => {
                            if(!checked) {
                                setError(true);
                                return;
                            }
                            onClose();
                        }}
                        label="Envoyer"
                    />
                </Box>
            </Box>
            <Box style={{ width: '100%' }} justify="center" align="center" pad={"medium"}>
                <Text
                    size={"small"}
                >
                    Trustiway, en tant que responsable de traitement, traite les données recueillies à des fins de gestion pour proposer à l’utilisateur une expérience optimale. Pour en savoir plus, {' '}
                    <a href="https://www.trustiway.com/lettre-dinformation-sur-les-traitements-des-donnees-personnels/">
                        reportez-vous à la politique de protection des données personnelles
                    </a>
                </Text>
            </Box>
            {error && <Box justify="center"><Text size="xsmall" style={{fontStyle: 'italic', color: 'red'}}>Veuillez cocher la case</Text></Box>}
        </Box>
    )
}

export default DataPersonnel;


const acceptCollectInfo = () => {
    localStorage.setItem(window.location.pathname, true);
}
const hasAcceptedCollectInfo = () => {
    if(typeof window !== 'undefined') {
        return localStorage.getItem(window.location.pathname);
    }
}
export {
    acceptCollectInfo,
    hasAcceptedCollectInfo
}

